






























































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, deepCopy } from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const tableList = [
  {
    id: 1,
    type: '海外版',
    channel: '兔兔官网',
    bundleId: 'com.tutuapp.tutuapphwenterprise',
    appName: 'tutuApp',
    appSize: '23MB',
    appVersion: 'v2.4.1',
    newFunction: '优化用户体验',
    state: 0,
    effect: 1,
    updateDate: '2019/08/25'
  }
]

@Component({
  name: 'ProductionIosList'
})
export default class extends mixins(DateOption) {
  // data
  params = {
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  tableLoading = false
  tableData: any[] = []
  totalCount: number = 0
  dateArray: string[] = ['', '']
  tableHeight: number = 800
  // lifecycle
  created() {
    this.getTableData()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  getTableData() {
    this.tableLoading = true
    for (let i = 0; i < 10; i++) {
      this.tableData.push(tableList[0])
    }
    this.tableLoading = false
  }
  handleDateChange(date: string[] | any) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 310
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    this.params.page = 1
    this.dateArray = ['', '']
  }
  handleAdd() {
    this['$router'].push({
      name: 'ProductionIosAdd'
    })
  }
  handleEdit(item: any) {
    this['$router'].push({
      name: 'ProductionIosEdit',
      query: {
        id: item.id
      }
    })
  }
  handleView(item: any) {
    this['$router'].push({
      name: 'ProductionIosView',
      query: {
        id: item.id
      }
    })
  }
  handleEffect(item: any) {
    const { id, effect } = item
  }
  handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getIosList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'name',
    //   'developer',
    //   'category',
    //   'source',
    //   'version',
    //   'price',
    //   'socre',
    //   'status',
    //   'editor',
    //   'updateDate'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '名称',
    //   '开发者',
    //   '类别',
    //   '来源',
    //   '版本',
    //   '价格',
    //   '评分',
    //   '应用状态',
    //   '编辑人',
    //   '最后修改时间'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }
}
